var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4191 22.0645C7.77774 22.0645 7.25781 22.5844 7.25781 23.2257C7.25781 23.8671 7.77774 24.387 8.4191 24.387H26.2925C26.8934 24.387 27.0985 25.1881 26.5715 25.4769L17.3119 30.5507C14.6768 31.9946 15.7022 35.9999 18.707 35.9999H41.2255C41.8669 35.9999 42.3868 35.48 42.3868 34.8386C42.3868 34.1973 41.8669 33.6774 41.2255 33.6774H18.707C18.106 33.6774 17.901 32.8763 18.428 32.5875L27.6876 27.5137C30.3227 26.0698 29.2973 22.0645 26.2925 22.0645L8.4191 22.0645Z",
    fill: "#FABA66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3727 35.5261C44.7225 31.8319 51.0968 22.07 51.0968 17.1077C51.0968 16.574 51.053 16.0506 50.9687 15.5407C50.1545 19.7717 44.307 30.5319 38.671 32.3079C39.4523 33.6093 40.1505 34.7256 40.6597 35.5261C41.062 36.1586 41.9703 36.1586 42.3727 35.5261Z",
    fill: "#D2171E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5162 7.54883C36.2249 7.54883 31.9355 11.8285 31.9355 17.1077C31.9355 22.07 35.8466 27.6038 38.671 32.3079C44.307 30.5319 50.1545 19.7717 50.9687 15.5407C50.2194 11.007 46.2725 7.54883 41.5162 7.54883ZM41.5162 21.6521C44.0317 21.6521 46.0709 19.6175 46.0709 17.1077C46.0709 14.5979 44.0317 12.5633 41.5162 12.5633C39.0007 12.5633 36.9615 14.5979 36.9615 17.1077C36.9615 19.6175 39.0007 21.6521 41.5162 21.6521Z",
    fill: "#E82F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2544 8.80245C36.6282 8.80245 32.8779 12.5442 32.8779 17.1599C32.8779 18.9267 33.4274 20.5655 34.3652 21.9154C34.4368 22.0184 34.5754 21.9272 34.5221 21.8136C30.3046 12.8291 40.3399 5.82084 48.0309 12.5849C48.1217 12.6648 48.2534 12.565 48.1854 12.4651C46.6781 10.2544 44.1362 8.80245 41.2544 8.80245Z",
    fill: "#ED5E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85574 23.9805C10.8495 20.8141 16.2581 12.4467 16.2581 8.19333C16.2581 7.73588 16.2209 7.28719 16.1494 6.85016C15.4585 10.4767 10.497 19.6998 5.7149 21.2221C6.37787 22.3375 6.97027 23.2943 7.40232 23.9805C7.74369 24.5226 8.51438 24.5226 8.85574 23.9805Z",
    fill: "#D2171E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12903 0C3.63949 0 0 3.66829 0 8.19333C0 12.4467 3.31846 17.1899 5.7149 21.2221C10.497 19.6998 15.4585 10.4767 16.1494 6.85016C15.5135 2.96411 12.1647 0 8.12903 0ZM8.12903 12.0885C10.2634 12.0885 11.9937 10.3446 11.9937 8.19333C11.9937 6.04207 10.2634 4.29814 8.12903 4.29814C5.99466 4.29814 4.26441 6.04207 4.26441 8.19333C4.26441 10.3446 5.99466 12.0885 8.12903 12.0885Z",
    fill: "#E82F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90693 1.07454C3.98165 1.07454 0.799577 4.28177 0.799577 8.2381C0.799577 9.7525 1.26581 11.1571 2.0615 12.3142C2.12226 12.4025 2.23987 12.3243 2.19463 12.227C-1.38385 4.52594 7.13098 -1.48113 13.6566 4.31668C13.7337 4.38513 13.8455 4.29955 13.7877 4.21396C12.5089 2.31907 10.3521 1.07454 7.90693 1.07454Z",
    fill: "#ED5E63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIcon);
export default __webpack_public_path__ + "static/media/workflowIcon.a29e8dabe732e775da2ce94ff7eb81ff.svg";
export { ForwardRef as ReactComponent };